import { initialState } from "./../initialState";
import * as DomainActions from "./domainActions";

export const domainReducer = (state = initialState.domain, action) => {
    switch (action.type) {
        case DomainActions.SET_DATE_DOMAIN:
            const { start, end } = action;

            return Object.assign({}, state, {
                dateRange: {
                    start,
                    end,
                },
            });

        case DomainActions.SET_LOCALE_LANG:
            const { lang } = action;
            var locale = Object.assign({}, state.locale, {
                lang,
            });

            return Object.assign({}, state, {
                locale,
            });

        case DomainActions.SET_LOCALE_MESSAGES:
            const { messages } = action;
            locale = Object.assign({}, state.locale, {
                messages,
            });

            return Object.assign({}, state, {
                locale,
            });

        default:
            return state;
    }
};
